var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45310_200670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8685 0.4375H1.86849C1.13211 0.4375 0.535156 1.03445 0.535156 1.77083V22.7708C0.535156 23.5072 1.13211 24.1042 1.86849 24.1042H22.8685C23.6049 24.1042 24.2018 23.5072 24.2018 22.7708V1.77083C24.2018 1.03445 23.6049 0.4375 22.8685 0.4375Z",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8659 18.9375H3.86589C3.77384 18.9375 3.69922 19.0121 3.69922 19.1042C3.69922 19.1962 3.77384 19.2708 3.86589 19.2708H20.8659C20.9579 19.2708 21.0326 19.1962 21.0326 19.1042C21.0326 19.0121 20.9579 18.9375 20.8659 18.9375Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_45310_200670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2777 5.9375C13.4944 5.9375 13.6729 6.09768 13.6957 6.30346L13.6982 6.34821V7.96459C13.6982 8.19143 13.5099 8.37531 13.2777 8.37531C13.0609 8.37531 12.8825 8.21513 12.8597 8.00935L12.8572 7.96459L12.8569 6.75893H4.87224V7.96459C4.87224 8.1763 4.70824 8.3506 4.49756 8.3729L4.45174 8.37531C4.23499 8.37531 4.05655 8.21513 4.03372 8.00935L4.03125 7.96459V6.34821C4.03125 6.13651 4.19525 5.96221 4.40593 5.93991L4.45174 5.9375H13.2777Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5193 14.5547C10.7515 14.5547 10.9398 14.7386 10.9398 14.9654C10.9398 15.1771 10.7758 15.3514 10.5651 15.3737L10.5193 15.3761H7.20956C6.97732 15.3761 6.78906 15.1922 6.78906 14.9654C6.78906 14.7537 6.95306 14.5794 7.16374 14.5571L7.20956 14.5547H10.5193Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86581 5.9375C9.08256 5.9375 9.261 6.09768 9.28383 6.30346L9.2863 6.34821V14.9689C9.2863 15.1957 9.09804 15.3796 8.86581 15.3796C8.64906 15.3796 8.47061 15.2194 8.44778 15.0137L8.44531 14.9689V6.34821C8.44531 6.12138 8.63357 5.9375 8.86581 5.9375Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45310_200670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.367188 0.273438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_45310_200670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(3.69922 5.27344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLineIcon);
export default __webpack_public_path__ + "static/media/single-line-icon.662013a23b2aafb805ef8278c3d400d0.svg";
export { ForwardRef as ReactComponent };